/* @flow */
import FooterNavItem from './FooterNavItem.jsx';
import Glyph from 'components/Glyph.jsx';
import LinkConstants from 'constants/LinkConstants';
import React from 'react';

import './styles/Footer.scss';

class Footer extends React.Component {
  render() {
    return (
      <footer className="Footer">
        <div className="Footer-container">
          <nav className="Footer-nav">
            <FooterNavItem href={LinkConstants.TERMS_OF_SERVICE} color="violet" divided>
              <Glyph name="lock-stroke" />
              Terms & Privacy
            </FooterNavItem>
            <FooterNavItem href={LinkConstants.HOW_IT_WORKS_TEACHERS}>Learn More</FooterNavItem>
            <FooterNavItem href={LinkConstants.RESOURCES}>Resources</FooterNavItem>
            <FooterNavItem href={LinkConstants.BLOG}>Blog</FooterNavItem>
            <FooterNavItem href={LinkConstants.COMMUNITY}>Community</FooterNavItem>
            <FooterNavItem href={LinkConstants.ABOUT}>About Us</FooterNavItem>
            <FooterNavItem href={LinkConstants.PRESS}>Press</FooterNavItem>
            <FooterNavItem href={LinkConstants.CAREERS}>Careers</FooterNavItem>
            <FooterNavItem href={LinkConstants.HELP}>Support</FooterNavItem>
          </nav>
        </div>
      </footer>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.jsx